webpackJsonp([308],{

/***/ "0GrG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);

var SpinLoader = function SpinLoader(_ref) {
  var size = _ref.size;
  var _sizeToNumber$size = sizeToNumber[size],
      loaderSize = _sizeToNumber$size.height,
      borderSize = _sizeToNumber$size.borderSize;

  var styles = {
    width: loaderSize,
    height: loaderSize,
    borderWidth: borderSize
  };
  var centeredRing = {
    transform: 'translateX(' + -(styles.width / 2) + 'px)'
  };
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { 'class': 'lds-ring', style: centeredRing },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { style: styles }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { style: styles }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { style: styles }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { style: styles })
  );
};

SpinLoader.defaultProps = {
  size: 'medium'
};

var sizeToNumber = {
  large: {
    height: 100,
    borderSize: 8
  },
  medium: {
    height: 50,
    borderSize: 6
  },
  small: {
    height: 30,
    borderSize: 4
  },
  xsmall: {
    height: 24,
    borderSize: 2
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SpinLoader);

/***/ }),

/***/ "9dgH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return onLimitCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return closeLimitCheckModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__("9vGq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__onModalAction_actionType__ = __webpack_require__("ptCC");



var onLimitCheck = function onLimitCheck(lenderId, lenderLogo, userMobileNum) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["y" /* modalActionType */].SHOW_MODAL,
      payload: {
        modalType: __WEBPACK_IMPORTED_MODULE_1__onModalAction_actionType__["b" /* modalType */].limitCheckDetailsModal,
        info: { lenderId: lenderId, lenderLogo: lenderLogo, userMobileNum: userMobileNum }
      }
    });
  };
};

var closeLimitCheckModal = function closeLimitCheckModal() {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["y" /* modalActionType */].HIDE_MODAL,
      payload: {
        modalType: __WEBPACK_IMPORTED_MODULE_1__onModalAction_actionType__["b" /* modalType */].limitCheckDetailsModal,
        info: {}
      }
    });
  };
};

/***/ }),

/***/ "9yVr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact/compat/dist/compat.module.js
var compat_module = __webpack_require__("AQ6k");

// EXTERNAL MODULE: ../node_modules/react-redux/es/index.js + 6 modules
var es = __webpack_require__("jYI/");

// EXTERNAL MODULE: ./actions/onModalAction/actionType.js
var onModalAction_actionType = __webpack_require__("ptCC");

// EXTERNAL MODULE: ./actionTypes/index.js
var actionTypes = __webpack_require__("9vGq");

// CONCATENATED MODULE: ./actions/onModalAction/index.js


/* harmony default export */ var actions_onModalAction = (function (actionType) {
  return function (dispatch) {
    switch (actionType) {
      case onModalAction_actionType["a" /* default */].closeModal:
        return dispatch({
          type: actionTypes["y" /* modalActionType */].HIDE_MODAL,
          payload: {}
        });
      default:
        return null;
    }
  };
});
// EXTERNAL MODULE: ../node_modules/preact-material-components/Dialog/style.css
var style = __webpack_require__("sEh6");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./components/partial/layers/modals/cancelTransactionModal/style.css
var cancelTransactionModal_style = __webpack_require__("PQwg");
var cancelTransactionModal_style_default = /*#__PURE__*/__webpack_require__.n(cancelTransactionModal_style);

// EXTERNAL MODULE: ../node_modules/preact-material-components/Dialog/index.js
var Dialog = __webpack_require__("JtzT");
var Dialog_default = /*#__PURE__*/__webpack_require__.n(Dialog);

// EXTERNAL MODULE: ./components/submitButton/index.js
var submitButton = __webpack_require__("pgW2");

// EXTERNAL MODULE: ./tracking/index.js
var tracking = __webpack_require__("Z0Lr");

// EXTERNAL MODULE: ./actions/onPaymentCancel/index.js + 1 modules
var onPaymentCancel = __webpack_require__("zhx8");

// EXTERNAL MODULE: ./actions/onPaymentCancel/actionType.js
var onPaymentCancel_actionType = __webpack_require__("H/Gn");

// EXTERNAL MODULE: ./components/cancelTransactionButton/style.css
var cancelTransactionButton_style = __webpack_require__("zed/");
var cancelTransactionButton_style_default = /*#__PURE__*/__webpack_require__.n(cancelTransactionButton_style);

// CONCATENATED MODULE: ./components/cancelTransactionButton/confirmCancelButton.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


/** @jsx h */







var confirmCancelButton_ConfirmCancelButton = function ConfirmCancelButton(props) {
  var isPosTransaction = props.isPosTransaction;

  var onClickAction = function onClickAction() {
    props.onPaymentCancel(onPaymentCancel_actionType["a" /* default */].confirmCancellation);
    var metadataObj = _extends({}, props.metadata);
    if (!isPosTransaction) {
      var cancellationReason = props.cancellationReason;
      metadataObj.cancellationType = cancellationReason;
      if (cancellationReason.includes('other:')) {
        cancellationReason = cancellationReason.split(':')[1];
        metadataObj.cancellationType = 'other';
      }
      metadataObj.cancellationReason = cancellationReason;
    }

    tracking["e" /* tracker */].trackUserInteraction(tracking["c" /* UserActionType */].CLICK, 'confirm_cancel', props.pageKey, metadataObj);
  };
  return Object(preact_min["h"])(
    'div',
    { className: isPosTransaction ? cancelTransactionButton_style_default.a.cancelButtonContainer : '' },
    Object(preact_min["h"])(
      'button',
      {
        className: (!isPosTransaction ? cancelTransactionButton_style_default.a.cancelButton : '') + ' text80 text-center cursorPointer',
        id: 'confirmCancelTransaction',
        onClick: onClickAction },
      'Cancel Transaction'
    )
  );
};

/* harmony default export */ var confirmCancelButton = (Object(es["b" /* connect */])(null, { onPaymentCancel: onPaymentCancel["a" /* default */] })(confirmCancelButton_ConfirmCancelButton));
// EXTERNAL MODULE: ./constants/index.js + 4 modules
var constants = __webpack_require__("mV6u");

// EXTERNAL MODULE: ../node_modules/preact-material-components/TextField/index.js
var TextField = __webpack_require__("Cv2I");
var TextField_default = /*#__PURE__*/__webpack_require__.n(TextField);

// EXTERNAL MODULE: ../node_modules/preact-material-components/TextField/style.css
var TextField_style = __webpack_require__("qKn3");
var TextField_style_default = /*#__PURE__*/__webpack_require__.n(TextField_style);

// CONCATENATED MODULE: ./components/partial/layers/modals/cancelTransactionModal/cancellationReasonList.js







var cancellationReasonList_CancellationReasonList = function CancellationReasonList(_ref) {
  var setCancellationReason = _ref.setCancellationReason,
      pageKey = _ref.pageKey;

  var _useState = Object(compat_module["useState"])(pageKey === 'pv_aivf_page_aivf' ? JSON.parse(JSON.stringify(constants["n" /* otpPageCancellationReasons */])) : JSON.parse(JSON.stringify(constants["d" /* cancellationReasons */]))),
      options = _useState[0],
      setOptions = _useState[1];

  var _useState2 = Object(compat_module["useState"])(false),
      isCustomReasonOpen = _useState2[0],
      setIsCustomReasonOpen = _useState2[1];

  var _onChange = function _onChange(selectedIndex) {
    setCancellationReason('');
    if (selectedIndex === options.length - 1) {
      setIsCustomReasonOpen(true);
    } else {
      setIsCustomReasonOpen(false);
    }
    var updatedOptions = options.map(function (option, index) {
      if (index === selectedIndex) {
        option.checked = true;
        index !== options.length - 1 && setCancellationReason(option.reason);
      } else {
        option.checked = false;
      }
      return option;
    });
    setOptions(updatedOptions);
  };

  var captureCustomReason = function captureCustomReason(e) {
    setCancellationReason('other:' + e.target.value);
  };

  return Object(preact_min["h"])(
    'div',
    null,
    Object(preact_min["h"])(
      'div',
      {
        className: cancelTransactionModal_style_default.a.listSubHeading + ' bold-text text-center font16 text80' },
      'Tell us why you want to cancel'
    ),
    options.map(function (option, i) {
      var _h;

      return Object(preact_min["h"])(
        'div',
        { key: option.labelText },
        Object(preact_min["h"])(
          'div',
          { className: cancelTransactionModal_style_default.a.radioContainer },
          Object(preact_min["h"])('input', (_h = {
            type: 'radio',
            id: 'radio-' + i,
            checked: 'checked',
            name: 'Controlled Options'
          }, _h['checked'] = option.checked, _h.onChange = function onChange() {
            return _onChange(i);
          }, _h)),
          Object(preact_min["h"])(
            'label',
            { className: cancelTransactionModal_style_default.a.labelText, 'for': 'radio-' + i },
            option.reason
          )
        )
      );
    }),
    Object(preact_min["h"])(
      'div',
      { className: cancelTransactionModal_style_default.a.textAreaContainer },
      isCustomReasonOpen && Object(preact_min["h"])(TextField_default.a, {
        maxlength: '5000',
        textarea: true,
        label: 'Enter your reason here',
        onChange: captureCustomReason
      })
    )
  );
};

/* harmony default export */ var cancellationReasonList = (cancellationReasonList_CancellationReasonList);
// EXTERNAL MODULE: ./components/loader/GenericLoader.js
var GenericLoader = __webpack_require__("A6R7");

// EXTERNAL MODULE: ./utils/index.js
var utils_0 = __webpack_require__("DHvs");

// EXTERNAL MODULE: ./components/blockResult/index.js
var blockResult = __webpack_require__("FipF");

// EXTERNAL MODULE: ./alias/paymentRoutes.js
var paymentRoutes = __webpack_require__("ejdM");

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ./utils/deviceType.js
var deviceType = __webpack_require__("i+25");

// CONCATENATED MODULE: ./components/partial/layers/modals/cancelTransactionModal/transactionCancelBody.js

/** @jsx h */

















var transactionCancelBody__ref3 = Object(preact_min["h"])(GenericLoader["a" /* default */], { loadingMsg: 'We are processing your transaction cancellation.' });

var _ref4 = Object(preact_min["h"])('img', { src: 'https://iccdn.in/img/ic-cancel.svg' });

var _ref5 = Object(preact_min["h"])(
  'div',
  { className: 'font14 text-center text80' },
  'Transaction cancelled.'
);

var _ref6 = Object(preact_min["h"])('img', { src: 'https://iccdn.in/img/ic-error.svg' });

var _ref7 = Object(preact_min["h"])(
  Dialog_default.a.Header,
  null,
  Object(preact_min["h"])(
    'div',
    { className: 'text-center bold-800 font20 text80 text-color' },
    'Cancel Transaction?'
  )
);

var transactionCancelBody_TransactionCancelBody = function TransactionCancelBody(props) {
  var _ref = props || {},
      pgData = _ref.pgData,
      returnUrl = _ref.returnUrl,
      apiState = _ref.apiState,
      pageKey = _ref.pageKey,
      errorMessage = _ref.errorMessage,
      closeModal = _ref.closeModal,
      metadata = _ref.metadata,
      channel = _ref.channel,
      sourceRef = _ref.sourceRef;

  var utils = new utils_0["c" /* default */]();

  var _useState = Object(compat_module["useState"])(''),
      cancellationReason = _useState[0],
      setCancellationReason = _useState[1];

  Object(compat_module["useEffect"])(function () {
    tracking["e" /* tracker */].trackUserInteraction(tracking["c" /* UserActionType */].MODAL, 'cancel_pop_up', pageKey, metadata);
  }, []);

  var transactingDeviceType = utils_0["c" /* default */].getDeviceType(channel, sourceRef);
  var isPosTransaction = transactingDeviceType === deviceType["a" /* deviceType */].POS_MACHINE || transactingDeviceType === deviceType["a" /* deviceType */].POS_USER_MOBILE;

  var _ref2 = Object(preact_min["h"])(cancellationReasonList, {
    setCancellationReason: setCancellationReason,
    pageKey: pageKey
  });

  var message = function message() {
    if (isPosTransaction) {
      return 'Transaction will be cancelled. You will have to re-initiate the transaction on the POS device to complete sale';
    } else if (pageKey === 'pv_payment_enter_mobile_mob') {
      return 'If you cancel the transaction, you will be taken back to the merchant website.';
    } else return _ref2;
  };

  var submitReturnUrl = function submitReturnUrl() {
    if (channel && (channel === 'OFFLINE' && !sourceRef || channel === 'PAYMENT_LINK')) {
      Object(preact_router_es["route"])('' + paymentRoutes["p" /* posCustomerPaymentFailureRoute */].path, true);
      closeModal();
      return;
    }
    utils.createAndSubmitDynamicForm(pgData, returnUrl, 0);
  };

  if (apiState === actionTypes["i" /* apiStatus */].INITIATED) {
    return Object(preact_min["h"])(
      'div',
      { className: cancelTransactionModal_style_default.a.loaderWrapper },
      transactionCancelBody__ref3
    );
  } else if (apiState === actionTypes["i" /* apiStatus */].SUCCESS) {
    return Object(preact_min["h"])(
      'div',
      { className: cancelTransactionModal_style_default.a.successMessage },
      _ref4,
      _ref5,
      Object(preact_min["h"])(blockResult["a" /* default */], {
        visibilityTimeUntilRedirect: 3,
        displayMessage: 'Returning in ',
        buttonText: 'Return Now',
        submitFormCallback: submitReturnUrl
      })
    );
  } else if (apiState === actionTypes["i" /* apiStatus */].ERROR) {
    return Object(preact_min["h"])(
      'div',
      { className: cancelTransactionModal_style_default.a.loaderWrapper },
      _ref6,
      Object(preact_min["h"])(
        'div',
        { className: 'font14 text-center text80' },
        errorMessage || 'Something Went wrong. Please try it in some time'
      )
    );
  }

  return Object(preact_min["h"])(
    'div',
    null,
    _ref7,
    Object(preact_min["h"])(
      Dialog_default.a.Body,
      null,
      Object(preact_min["h"])(
        'div',
        { className: cancelTransactionModal_style_default.a.bodyWrapper + ' font14 text80' },
        message()
      )
    ),
    Object(preact_min["h"])(
      Dialog_default.a.Footer,
      null,
      Object(preact_min["h"])(
        'div',
        { className: cancelTransactionModal_style_default.a.buttonContainer },
        isPosTransaction ? Object(preact_min["h"])(
          'div',
          null,
          ' ',
          Object(preact_min["h"])(submitButton["a" /* default */], {
            pageKey: pageKey,
            elementName: 'continue_transaction',
            buttonText: 'Continue with transaction',
            className: cancelTransactionModal_style_default.a.confirmCancellation + ' font14',
            buttonOnClick: closeModal,
            trackClickEvent: false
          }),
          Object(preact_min["h"])(confirmCancelButton, {
            pageKey: pageKey,
            metadata: metadata,
            cancellationReason: cancellationReason,
            isPosTransaction: isPosTransaction
          })
        ) : Object(preact_min["h"])(
          'div',
          null,
          ' ',
          Object(preact_min["h"])(
            'div',
            { className: cancelTransactionModal_style_default.a.outerButtonContainer },
            Object(preact_min["h"])(confirmCancelButton, {
              pageKey: pageKey,
              metadata: metadata,
              cancellationReason: cancellationReason,
              isPosTransaction: isPosTransaction
            }),
            Object(preact_min["h"])(submitButton["a" /* default */], {
              pageKey: pageKey,
              elementName: 'continue_transaction',
              buttonText: 'Continue with Purchase',
              className: cancelTransactionModal_style_default.a.confirmCancellation + ' font14',
              buttonOnClick: closeModal,
              trackClickEvent: false
            })
          )
        )
      )
    )
  );
};

var mapStateToProps = function mapStateToProps(_ref8) {
  var config = _ref8.config,
      modal = _ref8.modal,
      paymentUserData = _ref8.paymentUserData,
      paymentDetails = _ref8.paymentDetails;

  var _ref9 = config || {},
      pageKey = _ref9.pageKey,
      metadata = _ref9.metadata,
      sourceRef = _ref9.sourceRef;

  var _ref10 = paymentDetails || {},
      channel = _ref10.channel;

  var _ref11 = modal || {},
      cancelTransaction = _ref11.cancelTransaction;

  var _ref12 = cancelTransaction || {},
      apiState = _ref12.apiState,
      errorMessage = _ref12.errorMessage;

  var _ref13 = paymentUserData || {},
      pgData = _ref13.pgData,
      returnUrl = _ref13.returnUrl;

  return {
    pageKey: pageKey,
    apiState: apiState,
    errorMessage: errorMessage,
    pgData: pgData,
    returnUrl: returnUrl,
    metadata: metadata,
    sourceRef: sourceRef,
    channel: channel,
    paymentDetails: paymentDetails
  };
};
/* harmony default export */ var transactionCancelBody = (Object(es["b" /* connect */])(mapStateToProps)(transactionCancelBody_TransactionCancelBody));
// CONCATENATED MODULE: ./components/partial/layers/modals/cancelTransactionModal/index.js

/** @jsx h */





var cancelTransactionModal_CancelTransactionModal = function CancelTransactionModal(_ref) {
  var closeModal = _ref.closeModal;

  return Object(preact_min["h"])(
    'div',
    { className: cancelTransactionModal_style_default.a.container },
    Object(preact_min["h"])(transactionCancelBody, { closeModal: closeModal })
  );
};

/* harmony default export */ var cancelTransactionModal = (cancelTransactionModal_CancelTransactionModal);
// EXTERNAL MODULE: ./components/partial/layers/modals/helpTransactionModal/style.css
var helpTransactionModal_style = __webpack_require__("vZQi");
var helpTransactionModal_style_default = /*#__PURE__*/__webpack_require__.n(helpTransactionModal_style);

// CONCATENATED MODULE: ./components/partial/layers/modals/helpTransactionModal/transactionHelpBody.js

/** @jsx h */





var transactionHelpBody_TransactionHelpBody = function TransactionHelpBody(props) {
  var _ref = props || {},
      transactionHelpTitle = _ref.transactionHelpTitle,
      HelpText = _ref.helpText,
      pageKey = _ref.pageKey;

  return Object(preact_min["h"])(
    'div',
    null,
    Object(preact_min["h"])(
      'div',
      { className: helpTransactionModal_style_default.a.headerContainer },
      Object(preact_min["h"])(
        'div',
        { className: 'font20 text80 bold-text text-center' },
        transactionHelpTitle
      )
    ),
    Object(preact_min["h"])(
      'div',
      null,
      Object(preact_min["h"])(HelpText, null)
    ),
    Object(preact_min["h"])(
      'div',
      null,
      Object(preact_min["h"])(submitButton["a" /* default */], {
        buttonText: 'OK',
        buttonOnClick: props.closeModal,
        elementName: 'help_modal_close',
        buttonId: 'help-text-close',
        pageKey: pageKey,
        className: helpTransactionModal_style_default.a.submitButton,
        trackClickEvent: false
      })
    )
  );
};

var transactionHelpBody_mapStateToProps = function mapStateToProps(_ref2) {
  var modal = _ref2.modal,
      config = _ref2.config;

  var _ref3 = modal || {},
      transactionHelpText = _ref3.transactionHelpText;

  var _ref4 = transactionHelpText || {},
      transactionType = _ref4.transactionType,
      transactionHelpTitle = _ref4.transactionHelpTitle,
      helpText = _ref4.helpText;

  var pageKey = config.pageKey;

  return {
    transactionType: transactionType,
    transactionHelpTitle: transactionHelpTitle,
    helpText: helpText,
    pageKey: pageKey
  };
};
/* harmony default export */ var transactionHelpBody = (Object(es["b" /* connect */])(transactionHelpBody_mapStateToProps)(transactionHelpBody_TransactionHelpBody));
// CONCATENATED MODULE: ./components/partial/layers/modals/helpTransactionModal/index.js

/** @jsx h */




var helpTransactionModal_HelpTransactionModal = function HelpTransactionModal(_ref) {
  var closeModal = _ref.closeModal;

  return Object(preact_min["h"])(
    'div',
    { className: helpTransactionModal_style_default.a.container },
    Object(preact_min["h"])(transactionHelpBody, { closeModal: closeModal })
  );
};

/* harmony default export */ var helpTransactionModal = (helpTransactionModal_HelpTransactionModal);
// EXTERNAL MODULE: ./components/partial/layers/modals/errorBlockTransactionModal/style.css
var errorBlockTransactionModal_style = __webpack_require__("Wk37");
var errorBlockTransactionModal_style_default = /*#__PURE__*/__webpack_require__.n(errorBlockTransactionModal_style);

// EXTERNAL MODULE: ./components/spinLoader/index.js
var spinLoader = __webpack_require__("0GrG");

// CONCATENATED MODULE: ./components/partial/layers/modals/errorBlockTransactionModal/constant.js
var visibilityTimeUntilRedirect = 20;
// CONCATENATED MODULE: ./components/partial/layers/modals/errorBlockTransactionModal/transactionErrorBlockBody.js
var transactionErrorBlockBody__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


/** @jsx h */











var transactionErrorBlockBody_clickTracking = function clickTracking() {
  var pageKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Missing PageKey';
  var elementName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Missing ElementName';
  var additionalProperties = arguments[2];

  tracking["e" /* tracker */].trackUserInteraction(tracking["c" /* UserActionType */].CLICK, elementName, pageKey, additionalProperties);
};

var transactionErrorBlockBody__ref2 = Object(preact_min["h"])(spinLoader["a" /* default */], { size: 'xsmall' });

var transactionErrorBlockBody_TransactionErrorBlockBody = function TransactionErrorBlockBody(props) {
  var _ref = props || {},
      helpText = _ref.helpText,
      title = _ref.title,
      message = _ref.message,
      cta = _ref.cta,
      errorType = _ref.errorType,
      pageKey = _ref.pageKey,
      closeModal = _ref.closeModal,
      pgData = _ref.pgData,
      returnUrl = _ref.returnUrl,
      metadata = _ref.metadata,
      channel = _ref.channel,
      sourceRef = _ref.sourceRef,
      merchantName = _ref.merchantName;

  var interval = Object(compat_module["useRef"])();

  var isOfflineMobileDevice = function isOfflineMobileDevice() {
    return channel && channel === 'OFFLINE' && !sourceRef;
  };

  var _useState = Object(compat_module["useState"])(visibilityTimeUntilRedirect),
      redirectTimer = _useState[0],
      setRedirectTimer = _useState[1];

  Object(compat_module["useEffect"])(function () {
    interval.current = setInterval(function () {
      setRedirectTimer(function (seconds) {
        return seconds ? seconds - 1 : 0;
      });
    }, 1000);

    return function () {
      clearInterval(interval.current);
    };
  }, []);

  var handleTxnRedirection = function handleTxnRedirection() {
    if (channel && (channel === 'OFFLINE' || channel === 'PAYMENT_LINK')) {
      closeModal();
      Object(preact_router_es["route"])('' + paymentRoutes["p" /* posCustomerPaymentFailureRoute */].path, true);
      return;
    }
    if (returnUrl) {
      var utils = new utils_0["c" /* default */]();
      utils.createAndSubmitDynamicForm(pgData, returnUrl);
    } else {
      closeModal();
    }
  };

  var handleButton = function handleButton() {
    transactionErrorBlockBody_clickTracking(pageKey, 'Error', transactionErrorBlockBody__extends({}, errorType && { error_type: errorType }, message && { error_message: message }, title && { error_title: title }, metadata));
    handleTxnRedirection();
  };

  Object(compat_module["useEffect"])(function () {
    if (redirectTimer === 0) {
      handleTxnRedirection();
      clearInterval(interval.current);
      closeModal();
    }
  }, [redirectTimer]);

  return Object(preact_min["h"])(
    preact_min["Fragment"],
    null,
    title && Object(preact_min["h"])(
      'div',
      { className: errorBlockTransactionModal_style_default.a.headerContainer },
      Object(preact_min["h"])(
        'div',
        {
          className: 'font20 text80 bold-text text-center',
          id: 'transactionErrorPopupTitle' },
        title
      )
    ),
    message && Object(preact_min["h"])(
      'p',
      { className: 'font14 text60', id: 'transactionErrorPopupMessage' },
      channel === 'PAYMENT_LINK' && errorType === 'Eligibility' ? 'Transaction has been canceled' : message
    ),
    !isOfflineMobileDevice() && cta && channel !== 'PAYMENT_LINK' && Object(preact_min["h"])(
      'div',
      { className: errorBlockTransactionModal_style_default.a.buttonWrapper },
      Object(preact_min["h"])(
        'button',
        {
          className: errorBlockTransactionModal_style_default.a.goBackButton,
          onClick: handleButton,
          id: 'transactionErrorPopupBackBtn' },
        cta
      )
    ),
    helpText && Object(preact_min["h"])(
      'div',
      {
        className: 'font12 text-center text60 ' + errorBlockTransactionModal_style_default.a.helperText,
        id: 'transactionErrorPopupHelperText' },
      channel === 'PAYMENT_LINK' && errorType === 'Eligibility' ? 'Restart your payment from ' + (merchantName ? merchantName : 'the merchant') : helpText
    ),
    Object(preact_min["h"])(
      'div',
      { className: errorBlockTransactionModal_style_default.a.redirect__wrapper + ' block__modal--loader' },
      Object(preact_min["h"])(
        'div',
        {
          className: errorBlockTransactionModal_style_default.a.loader,
          id: 'transactionErrorPopupRedirectTimeLoader' },
        transactionErrorBlockBody__ref2
      ),
      Object(preact_min["h"])(
        'span',
        { className: errorBlockTransactionModal_style_default.a.redirect__text },
        'Redirecting in',
        ' ',
        Object(preact_min["h"])(
          'span',
          { className: errorBlockTransactionModal_style_default.a.timer, id: 'transactionErrorPopupRedirectTime' },
          redirectTimer,
          ' second',
          redirectTimer > 1 ? 's' : ''
        )
      )
    )
  );
};

var transactionErrorBlockBody_mapStateToProps = function mapStateToProps(_ref3) {
  var modal = _ref3.modal,
      config = _ref3.config,
      paymentDetails = _ref3.paymentDetails,
      paymentUserData = _ref3.paymentUserData;

  var _ref4 = paymentUserData || {},
      pgData = _ref4.pgData,
      returnUrl = _ref4.returnUrl;

  var _ref5 = modal || {},
      errorBlockTransaction = _ref5.errorBlockTransaction;

  var _ref6 = errorBlockTransaction || {},
      helpText = _ref6.helpText,
      title = _ref6.title,
      message = _ref6.message,
      cta = _ref6.cta,
      errorType = _ref6.errorType;

  var pageKey = config.pageKey,
      metadata = config.metadata,
      sourceRef = config.sourceRef;

  var _ref7 = paymentDetails || {},
      channel = _ref7.channel,
      merchantName = _ref7.merchantName;

  return {
    helpText: helpText,
    title: title,
    message: message,
    cta: cta,
    errorType: errorType,
    pageKey: pageKey,
    pgData: pgData,
    returnUrl: returnUrl,
    metadata: metadata,
    channel: channel,
    sourceRef: sourceRef,
    merchantName: merchantName
  };
};

/* harmony default export */ var transactionErrorBlockBody = (Object(es["b" /* connect */])(transactionErrorBlockBody_mapStateToProps)(transactionErrorBlockBody_TransactionErrorBlockBody));
// CONCATENATED MODULE: ./components/partial/layers/modals/errorBlockTransactionModal/index.js

/** @jsx h */




var errorBlockTransactionModal_ErrorBlockTransactionModal = function ErrorBlockTransactionModal(_ref) {
  var closeModal = _ref.closeModal;

  return Object(preact_min["h"])(
    'div',
    { className: errorBlockTransactionModal_style_default.a.container },
    Object(preact_min["h"])(transactionErrorBlockBody, { closeModal: closeModal })
  );
};

/* harmony default export */ var errorBlockTransactionModal = (errorBlockTransactionModal_ErrorBlockTransactionModal);
// EXTERNAL MODULE: ./components/partial/layers/modals/onLimitCheckModal/style.css
var onLimitCheckModal_style = __webpack_require__("U1xn");
var onLimitCheckModal_style_default = /*#__PURE__*/__webpack_require__.n(onLimitCheckModal_style);

// EXTERNAL MODULE: ./components/partial/layers/modals/onLimitCheckModal/limitCheckInfo.js
var limitCheckInfo = __webpack_require__("wM4X");

// EXTERNAL MODULE: ./actions/onLimitCheck/index.js
var onLimitCheck = __webpack_require__("9dgH");

// CONCATENATED MODULE: ./components/partial/layers/modals/onLimitCheckModal/index.js







var onLimitCheckModal__ref2 = Object(preact_min["h"])(
  'b',
  null,
  'SMS'
);

var onLimitCheckModal_OnLimitCheckModal = function OnLimitCheckModal(props) {
  var _ref = props || {},
      lenderId = _ref.lenderId,
      lenderLogo = _ref.lenderLogo,
      closeLimitCheckModal = _ref.closeLimitCheckModal,
      userMobileNum = _ref.userMobileNum;

  var selectedLenderInfo = limitCheckInfo["a" /* default */][lenderId];

  return Object(preact_min["h"])(
    'div',
    null,
    Object(preact_min["h"])(
      'div',
      { className: onLimitCheckModal_style_default.a.closeIconContainer },
      Object(preact_min["h"])('img', {
        src: 'https://iccdn.in/img/widget-img/widget-close-overlay.svg',
        alt: 'close',
        id: 'close-button',
        className: onLimitCheckModal_style_default.a.closeIcon,
        onClick: function onClick() {
          closeLimitCheckModal();
        }
      })
    ),
    Object(preact_min["h"])(
      'div',
      { className: onLimitCheckModal_style_default.a.lenderLogoContainer },
      Object(preact_min["h"])('img', { src: lenderLogo, alt: 'lender logo' })
    ),
    Object(preact_min["h"])(
      Dialog_default.a.Body,
      null,
      selectedLenderInfo ? Object(preact_min["h"])(
        'div',
        null,
        Object(preact_min["h"])(
          'div',
          { className: onLimitCheckModal_style_default.a.checkLimitText + ' text-center  font18' },
          'To check your limit, send ',
          onLimitCheckModal__ref2
        ),
        Object(preact_min["h"])(
          'div',
          {
            style: { color: '#227ae0' },
            className: 'text-center bold-text font20' },
          selectedLenderInfo.text
        ),
        Object(preact_min["h"])(
          'div',
          { className: onLimitCheckModal_style_default.a.checkLimitPromptText },
          'to ',
          Object(preact_min["h"])(
            'b',
            null,
            selectedLenderInfo.number
          ),
          ' from your registered number ending in ',
          Object(preact_min["h"])(
            'b',
            null,
            userMobileNum.slice(-4)
          )
        )
      ) : Object(preact_min["h"])(
        'div',
        {
          className: onLimitCheckModal_style_default.a.checkLimitText + ' text-center bold-text font18' },
        'You\'ll be able to check your limit soon'
      )
    )
  );
};

var onLimitCheckModal_mapStateToProps = function mapStateToProps(_ref3) {
  var modal = _ref3.modal;

  var _ref4 = modal || {},
      limitCheck = _ref4.limitCheck;

  var lenderId = limitCheck.lenderId,
      lenderLogo = limitCheck.lenderLogo,
      userMobileNum = limitCheck.userMobileNum;


  return {
    lenderId: lenderId,
    lenderLogo: lenderLogo,
    userMobileNum: userMobileNum
  };
};
/* harmony default export */ var onLimitCheckModal = (Object(es["b" /* connect */])(onLimitCheckModal_mapStateToProps, { closeLimitCheckModal: onLimitCheck["a" /* closeLimitCheckModal */] })(onLimitCheckModal_OnLimitCheckModal));
// EXTERNAL MODULE: ./components/partial/layers/modals/style.css
var modals_style = __webpack_require__("Z5MC");
var modals_style_default = /*#__PURE__*/__webpack_require__.n(modals_style);

// EXTERNAL MODULE: ./components/partial/layers/modals/aivfInfoModal/style.css
var aivfInfoModal_style = __webpack_require__("aGVp");
var aivfInfoModal_style_default = /*#__PURE__*/__webpack_require__.n(aivfInfoModal_style);

// CONCATENATED MODULE: ./components/partial/layers/modals/aivfInfoModal/infoCard.js

/** @jsx h */



var infoCard_InfoCard = function InfoCard(props) {
  var _ref = props || {},
      leftImage = _ref.leftImage,
      children = _ref.children;

  return Object(preact_min["h"])(
    'div',
    { className: aivfInfoModal_style_default.a.cardInfoContainer },
    Object(preact_min["h"])(
      'div',
      null,
      Object(preact_min["h"])('img', { src: leftImage, className: aivfInfoModal_style_default.a.leftImageContainer })
    ),
    Object(preact_min["h"])(
      'div',
      { className: aivfInfoModal_style_default.a.cardInfoTextContainer },
      children
    )
  );
};

/* harmony default export */ var infoCard = (infoCard_InfoCard);
// CONCATENATED MODULE: ./components/partial/layers/modals/aivfInfoModal/helper.js

/** @jsx h */


var helper__ref2 = Object(preact_min["h"])(
  'div',
  { className: 'font16 bold-text text80 line-height-20' },
  'Pre-approved'
);

var helper__ref3 = Object(preact_min["h"])(
  'span',
  { className: 'bold-text' },
  'No KYC required!'
);

var helper__ref4 = Object(preact_min["h"])(
  'div',
  { className: 'font16 bold-text text80 line-height-20' },
  'No Hidden Charges'
);

var helper__ref5 = Object(preact_min["h"])(
  'span',
  { className: 'bold-text' },
  '0 downpayment. '
);

var helper__ref6 = Object(preact_min["h"])(
  'div',
  { className: 'font16 bold-text text80 line-height-20' },
  'Safe and Secure'
);

var helper__ref7 = Object(preact_min["h"])(
  preact_min["Fragment"],
  null,
  Object(preact_min["h"])(
    'div',
    { className: 'font16 bold-text text80 line-height-20' },
    'Auto Repayment'
  ),
  Object(preact_min["h"])(
    'div',
    { className: 'font14 line-height-20' },
    Object(preact_min["h"])(
      'span',
      { className: 'text80' },
      'EMI amount will be directly debited from your account.',
      ' '
    ),
    Object(preact_min["h"])(
      'span',
      { className: 'bold-text' },
      'No setup required.'
    )
  )
);

var _ref8 = Object(preact_min["h"])(
  'div',
  { className: 'font16 bold-text text80 line-height-20' },
  'Pre-approved'
);

var _ref9 = Object(preact_min["h"])(
  'span',
  { className: 'bold-text' },
  'No KYC required!'
);

var _ref10 = Object(preact_min["h"])(
  'div',
  { className: 'font16 bold-text text80 line-height-20' },
  'No Hidden Charges'
);

var _ref11 = Object(preact_min["h"])(
  'span',
  { className: 'bold-text' },
  '0 downpayment. '
);

var _ref12 = Object(preact_min["h"])(
  'div',
  { className: 'font16 bold-text text80 line-height-20' },
  'Safe and Secure'
);

var _ref13 = Object(preact_min["h"])(
  preact_min["Fragment"],
  null,
  Object(preact_min["h"])(
    'div',
    { className: 'font16 bold-text text80 line-height-20' },
    'Auto Repayment'
  ),
  Object(preact_min["h"])(
    'div',
    { className: 'font14 line-height-20' },
    Object(preact_min["h"])(
      'span',
      { className: 'text80' },
      'EMI amount will be directly debited from account based on existing mandate.',
      ' '
    ),
    Object(preact_min["h"])(
      'span',
      { className: 'bold-text' },
      'No setup required.'
    )
  )
);

var _ref14 = Object(preact_min["h"])(
  'div',
  { className: 'font16 bold-text text80 line-height-20' },
  'Pre-approved'
);

var _ref15 = Object(preact_min["h"])(
  'span',
  { className: 'bold-text' },
  'No KYC required!'
);

var _ref16 = Object(preact_min["h"])(
  'div',
  { className: 'font16 bold-text text80 line-height-20' },
  'No Hidden Charges'
);

var _ref17 = Object(preact_min["h"])(
  'span',
  { className: 'bold-text' },
  '0 downpayment. '
);

var _ref18 = Object(preact_min["h"])(
  'div',
  { className: 'font16 bold-text text80 line-height-20' },
  'Safe and Secure'
);

var _ref19 = Object(preact_min["h"])(
  preact_min["Fragment"],
  null,
  Object(preact_min["h"])(
    'div',
    { className: 'font16 bold-text text80 line-height-20' },
    'Auto Repayment'
  ),
  Object(preact_min["h"])(
    'div',
    { className: 'font14 line-height-20' },
    Object(preact_min["h"])(
      'span',
      { className: 'text80' },
      'EMI amount will be directly debited from your account.',
      ' '
    ),
    Object(preact_min["h"])(
      'span',
      { className: 'bold-text' },
      'No setup required.'
    )
  )
);

var _ref20 = Object(preact_min["h"])(
  'div',
  { className: 'font16 bold-text text80 line-height-20' },
  'Pre-approved'
);

var _ref21 = Object(preact_min["h"])(
  'span',
  { className: 'bold-text' },
  'No KYC required!'
);

var _ref22 = Object(preact_min["h"])(
  'div',
  { className: 'font16 bold-text text80 line-height-20' },
  'No Hidden Charges'
);

var _ref23 = Object(preact_min["h"])(
  'span',
  { className: 'bold-text' },
  '0 downpayment. '
);

var _ref24 = Object(preact_min["h"])(
  'div',
  { className: 'font16 bold-text text80 line-height-20' },
  'Safe and Secure'
);

var _ref25 = Object(preact_min["h"])(
  preact_min["Fragment"],
  null,
  Object(preact_min["h"])(
    'div',
    { className: 'font16 bold-text text80 line-height-20' },
    'Auto Repayment'
  ),
  Object(preact_min["h"])(
    'div',
    { className: 'font14 line-height-20' },
    Object(preact_min["h"])(
      'span',
      { className: 'text80' },
      'EMI amount will be directly debited from your account.',
      ' '
    ),
    Object(preact_min["h"])(
      'span',
      { className: 'bold-text' },
      'No setup required.'
    )
  )
);

var _ref26 = Object(preact_min["h"])(
  'div',
  { className: 'font16 bold-text text80 line-height-20' },
  'Pre-approved'
);

var _ref27 = Object(preact_min["h"])(
  'span',
  { className: 'bold-text' },
  'No KYC required!'
);

var _ref28 = Object(preact_min["h"])(
  'div',
  { className: 'font16 bold-text text80 line-height-20' },
  'No Hidden Charges'
);

var _ref29 = Object(preact_min["h"])(
  'span',
  { className: 'bold-text' },
  'Zero down payment. '
);

var _ref30 = Object(preact_min["h"])(
  'div',
  { className: 'font16 bold-text text80 line-height-20' },
  'Safe and Secure'
);

var _ref31 = Object(preact_min["h"])(
  preact_min["Fragment"],
  null,
  Object(preact_min["h"])(
    'div',
    { className: 'font16 bold-text text80 line-height-20' },
    'Auto Repayment'
  ),
  Object(preact_min["h"])(
    'div',
    { className: 'font14 line-height-20' },
    Object(preact_min["h"])(
      'span',
      { className: 'text80' },
      'EMI amount will be directly debited from your account.',
      ' '
    ),
    Object(preact_min["h"])(
      'span',
      { className: 'bold-text' },
      'No setup required.'
    )
  )
);

var _ref32 = Object(preact_min["h"])(
  'div',
  { className: 'font16 bold-text text80 line-height-20' },
  'Pre-approved'
);

var _ref33 = Object(preact_min["h"])(
  'span',
  { className: 'bold-text' },
  'No KYC required!'
);

var _ref34 = Object(preact_min["h"])(
  'div',
  { className: 'font16 bold-text text80 line-height-20' },
  'No Hidden Charges'
);

var _ref35 = Object(preact_min["h"])(
  'span',
  { className: 'bold-text' },
  'Zero down payment. '
);

var _ref36 = Object(preact_min["h"])(
  'div',
  { className: 'font16 bold-text text80 line-height-20' },
  'Safe and Secure'
);

var _ref37 = Object(preact_min["h"])(
  preact_min["Fragment"],
  null,
  Object(preact_min["h"])(
    'div',
    { className: 'font16 bold-text text80 line-height-20' },
    'Auto Repayment'
  ),
  Object(preact_min["h"])(
    'div',
    { className: 'font14 line-height-20' },
    Object(preact_min["h"])(
      'span',
      { className: 'text80' },
      'EMI amount will be directly debited from your account.',
      ' '
    ),
    Object(preact_min["h"])(
      'span',
      { className: 'bold-text' },
      'No setup required.'
    )
  )
);

var helper_helper = function helper(_ref) {
  var lenderId = _ref.lenderId,
      lenderName = _ref.lenderName;

  switch (lenderId) {
    case '102':
      return {
        informationText: 'Just enter the 4 digits of your Debit card and OTP',
        infoDetails: [{
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-pre-appproved.png',
          textElement: Object(preact_min["h"])(
            preact_min["Fragment"],
            null,
            helper__ref2,
            Object(preact_min["h"])(
              'div',
              { className: 'font14 line-height-20' },
              Object(preact_min["h"])(
                'span',
                { className: 'text80' },
                'You are already pre-approved by ',
                lenderName,
                '.',
                ' '
              ),
              helper__ref3
            )
          )
        }, {
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-low-interest-rate.png',
          textElement: Object(preact_min["h"])(
            preact_min["Fragment"],
            null,
            helper__ref4,
            Object(preact_min["h"])(
              'div',
              { className: 'font14 line-height-20' },
              helper__ref5,
              Object(preact_min["h"])(
                'span',
                { className: 'text80' },
                'No additional fee charged by ',
                lenderName,
                '.'
              )
            )
          )
        }, {
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-safe-and-secure.png',
          textElement: Object(preact_min["h"])(
            preact_min["Fragment"],
            null,
            helper__ref6,
            Object(preact_min["h"])(
              'div',
              { className: 'font14 line-height-20' },
              Object(preact_min["h"])(
                'span',
                { className: 'text80' },
                'OTP is verified by ',
                lenderName,
                '.The platform is PCI DSS certified.'
              )
            )
          )
        }, {
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-zero-effort.png',
          textElement: helper__ref7
        }]
      };
    case '201':
    case '202':
      return {
        informationText: 'Just enter the 4 digits of your PAN card and OTP',
        infoDetails: [{
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-pre-appproved.png',
          textElement: Object(preact_min["h"])(
            preact_min["Fragment"],
            null,
            _ref8,
            Object(preact_min["h"])(
              'div',
              { className: 'font14 line-height-20' },
              Object(preact_min["h"])(
                'span',
                { className: 'text80' },
                'You are already pre-approved by ',
                lenderName,
                '.',
                ' '
              ),
              _ref9
            )
          )
        }, {
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-low-interest-rate.png',
          textElement: Object(preact_min["h"])(
            preact_min["Fragment"],
            null,
            _ref10,
            Object(preact_min["h"])(
              'div',
              { className: 'font14 line-height-20' },
              _ref11,
              Object(preact_min["h"])(
                'span',
                { className: 'text80' },
                'No additional fee charged by ',
                lenderName,
                '.'
              )
            )
          )
        }, {
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-safe-and-secure.png',
          textElement: Object(preact_min["h"])(
            preact_min["Fragment"],
            null,
            _ref12,
            Object(preact_min["h"])(
              'div',
              { className: 'font14 line-height-20' },
              Object(preact_min["h"])(
                'span',
                { className: 'text80' },
                'OTP is verified by ',
                lenderName,
                '. The platform is PCI DSS certified.'
              )
            )
          )
        }, {
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-zero-effort.png',
          textElement: _ref13
        }]
      };

    case '401':
      return {
        informationText: 'Just enter the 4 digits of your Debit card and OTP',
        infoDetails: [{
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-pre-appproved.png',
          textElement: Object(preact_min["h"])(
            preact_min["Fragment"],
            null,
            _ref14,
            Object(preact_min["h"])(
              'div',
              { className: 'font14 line-height-20' },
              Object(preact_min["h"])(
                'span',
                { className: 'text80' },
                'You are already pre-approved by ',
                lenderName,
                '.',
                ' '
              ),
              _ref15
            )
          )
        }, {
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-low-interest-rate.png',
          textElement: Object(preact_min["h"])(
            preact_min["Fragment"],
            null,
            _ref16,
            Object(preact_min["h"])(
              'div',
              { className: 'font14 line-height-20' },
              _ref17,
              Object(preact_min["h"])(
                'span',
                { className: 'text80' },
                'A nominal fee of \u20B9199 is charged by ',
                lenderName,
                '.'
              )
            )
          )
        },, {
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-safe-and-secure.png',
          textElement: Object(preact_min["h"])(
            preact_min["Fragment"],
            null,
            _ref18,
            Object(preact_min["h"])(
              'div',
              { className: 'font14 line-height-20' },
              Object(preact_min["h"])(
                'span',
                { className: 'text80' },
                'OTP is verified by ',
                lenderName,
                '. The platform is PCI DSS certified.'
              )
            )
          )
        }, {
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-zero-effort.png',
          textElement: _ref19
        }]
      };

    case '501':
      return {
        informationText: 'Just enter the 4 digits of your Debit card and OTP',
        infoDetails: [{
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-pre-appproved.png',
          textElement: Object(preact_min["h"])(
            preact_min["Fragment"],
            null,
            _ref20,
            Object(preact_min["h"])(
              'div',
              { className: 'font14 line-height-20' },
              Object(preact_min["h"])(
                'span',
                { className: 'text80' },
                'You are already pre-approved by ',
                lenderName,
                '.',
                ' '
              ),
              _ref21
            )
          )
        }, {
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-low-interest-rate.png',
          textElement: Object(preact_min["h"])(
            preact_min["Fragment"],
            null,
            _ref22,
            Object(preact_min["h"])(
              'div',
              { className: 'font14 line-height-20' },
              _ref23,
              Object(preact_min["h"])(
                'span',
                { className: 'text80' },
                'A nominal fee of \u20B9199 + GST is charged by ',
                lenderName,
                '.'
              )
            )
          )
        }, {
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-safe-and-secure.png',
          textElement: Object(preact_min["h"])(
            preact_min["Fragment"],
            null,
            _ref24,
            Object(preact_min["h"])(
              'div',
              { className: 'font14 line-height-20' },
              Object(preact_min["h"])(
                'span',
                { className: 'text80' },
                'OTP is verified by ',
                lenderName,
                '. The platform is PCI DSS certified.'
              )
            )
          )
        }, {
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-zero-effort.png',
          textElement: _ref25
        }]
      };

    case '601':
      return {
        informationText: 'Just enter the 4 digits of your Ujjwal card and OTP',
        infoDetails: [{
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-pre-appproved.png',
          textElement: Object(preact_min["h"])(
            preact_min["Fragment"],
            null,
            _ref26,
            Object(preact_min["h"])(
              'div',
              { className: 'font14 line-height-20' },
              Object(preact_min["h"])(
                'span',
                { className: 'text80' },
                'You are already pre-approved by ',
                lenderName,
                '.',
                ' '
              ),
              _ref27
            )
          )
        }, {
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-low-interest-rate.png',
          textElement: Object(preact_min["h"])(
            preact_min["Fragment"],
            null,
            _ref28,
            Object(preact_min["h"])(
              'div',
              { className: 'font14 line-height-20' },
              _ref29,
              Object(preact_min["h"])(
                'span',
                { className: 'text80' },
                'No additional fee charged by ',
                lenderName,
                '.'
              )
            )
          )
        }, {
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-safe-and-secure.png',
          textElement: Object(preact_min["h"])(
            preact_min["Fragment"],
            null,
            _ref30,
            Object(preact_min["h"])(
              'div',
              { className: 'font14 line-height-20' },
              Object(preact_min["h"])(
                'span',
                { className: 'text80' },
                'OTP is verified by ',
                lenderName,
                '. The platform is PCI DSS certified.'
              )
            )
          )
        }, {
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-zero-effort.png',
          textElement: _ref31
        }]
      };

    case '701':
      return {
        informationText: 'Just enter your PAN card number and OTP',
        infoDetails: [{
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-pre-appproved.png',
          textElement: Object(preact_min["h"])(
            preact_min["Fragment"],
            null,
            _ref32,
            Object(preact_min["h"])(
              'div',
              { className: 'font14 line-height-20' },
              Object(preact_min["h"])(
                'span',
                { className: 'text80' },
                'You are already pre-approved by ',
                lenderName,
                '.',
                ' '
              ),
              _ref33
            )
          )
        }, {
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-low-interest-rate.png',
          textElement: Object(preact_min["h"])(
            preact_min["Fragment"],
            null,
            _ref34,
            Object(preact_min["h"])(
              'div',
              { className: 'font14 line-height-20' },
              _ref35,
              Object(preact_min["h"])(
                'span',
                { className: 'text80' },
                'No additional fee charged by ',
                lenderName,
                '.'
              )
            )
          )
        }, {
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-safe-and-secure.png',
          textElement: Object(preact_min["h"])(
            preact_min["Fragment"],
            null,
            _ref36,
            Object(preact_min["h"])(
              'div',
              { className: 'font14 line-height-20' },
              Object(preact_min["h"])(
                'span',
                { className: 'text80' },
                'OTP is verified by ',
                lenderName,
                '. The platform is PCI DSS certified.'
              )
            )
          )
        }, {
          leftImage: 'https://iccdn.in/img/transaction/ic-transaction-zero-effort.png',
          textElement: _ref37
        }]
      };
    default:
      return {};
  }
};

/* harmony default export */ var aivfInfoModal_helper = (helper_helper);
// CONCATENATED MODULE: ./components/partial/layers/modals/aivfInfoModal/aivfInfo.js
var aivfInfo__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


/** @jsx h */







var aivfInfo__ref2 = Object(preact_min["h"])(
  'div',
  { className: 'font20 bold-text text80 text-center line-height-24' },
  'How Cardless EMI Works'
);

var aivfInfo_AivfInfo = function AivfInfo(props) {
  var _ref = props || {},
      pageKey = _ref.pageKey,
      metadata = _ref.metadata,
      lenderId = _ref.lenderId,
      lenderName = _ref.lenderName,
      closeModal = _ref.closeModal;

  var _helper = aivfInfoModal_helper({ lenderId: lenderId, lenderName: lenderName }),
      infoDetails = _helper.infoDetails,
      informationText = _helper.informationText;

  return Object(preact_min["h"])(
    'div',
    { className: aivfInfoModal_style_default.a.aivfInfoContainer },
    Object(preact_min["h"])(
      'div',
      { className: aivfInfoModal_style_default.a.aivfInfoHeaderContainer },
      Object(preact_min["h"])(
        'div',
        {
          className: aivfInfoModal_style_default.a.aivfHeaderText + ' font16 bold-text text80 text-center line-height-20' },
        'You are almost done!'
      ),
      Object(preact_min["h"])(
        'div',
        { className: 'font14 text80 line-height-20' },
        informationText
      )
    ),
    Object(preact_min["h"])(
      'div',
      { className: aivfInfoModal_style_default.a.aivfInfoBodyContainer },
      aivfInfo__ref2,
      infoDetails.map(function (itm) {
        var _ref3 = itm || {},
            leftImage = _ref3.leftImage,
            textElement = _ref3.textElement,
            rightImage = _ref3.rightImage;

        return Object(preact_min["h"])(
          infoCard,
          { leftImage: leftImage, rightImage: rightImage },
          textElement
        );
      }),
      Object(preact_min["h"])(
        'div',
        { className: aivfInfoModal_style_default.a.buttonContainer },
        Object(preact_min["h"])(submitButton["a" /* default */], {
          metadata: metadata,
          pageKey: pageKey,
          elementName: 'dismiss_how_it_works',
          buttonText: 'Ok, Got it',
          buttonOnClick: closeModal
        })
      )
    )
  );
};

var aivfInfo_mapStateToProps = function mapStateToProps(_ref4) {
  var paymentUserData = _ref4.paymentUserData,
      config = _ref4.config;

  var _ref5 = config || {},
      pageKey = _ref5.pageKey,
      metadata = _ref5.metadata;

  var _ref6 = paymentUserData || {},
      selectedLender = _ref6.selectedLender;

  var _ref7 = selectedLender || {},
      aivfType = _ref7.aivfType,
      lenderId = _ref7.lenderId,
      lenderName = _ref7.lenderName;

  return {
    pageKey: pageKey,
    metadata: aivfInfo__extends({}, metadata, {
      AIVF_Type: aivfType
    }),
    lenderId: lenderId.toString(),
    lenderName: lenderName
  };
};

/* harmony default export */ var aivfInfo = (Object(es["b" /* connect */])(aivfInfo_mapStateToProps)(aivfInfo_AivfInfo));
// CONCATENATED MODULE: ./components/partial/layers/modals/aivfInfoModal/index.js

/** @jsx h */



var aivfInfoModal_AivfInfoModal = function AivfInfoModal(_ref) {
  var closeModal = _ref.closeModal;

  return Object(preact_min["h"])(aivfInfo, { closeModal: closeModal });
};

/* harmony default export */ var aivfInfoModal = (aivfInfoModal_AivfInfoModal);
// EXTERNAL MODULE: ./components/material-ui/Modal/index.js
var material_ui_Modal = __webpack_require__("t9ax");

// CONCATENATED MODULE: ./components/partial/layers/modals/modal.js

/** @jsx h */














var modal__ref2 = Object(preact_min["h"])(onLimitCheckModal, null);

var modal_Modal = function Modal(props) {
  var _useState = Object(compat_module["useState"])(false),
      open = _useState[0],
      setOpen = _useState[1];

  var _ref = props || {},
      template = _ref.template,
      onModalAction = _ref.onModalAction,
      pageKey = _ref.pageKey;

  var prevTemplate = Object(compat_module["useRef"])('none');

  var showModal = Object(compat_module["useCallback"])(function () {
    setOpen(true);
    prevTemplate.current = template;
  }, []);

  var _closeModal = Object(compat_module["useCallback"])(function () {
    setOpen(false);
    onModalAction(onModalAction_actionType["a" /* default */].closeModal);

    prevTemplate.current = template;
  }, []);

  var sendCancelTransactionTracking = function sendCancelTransactionTracking() {
    tracking["e" /* tracker */].trackUserInteraction(tracking["c" /* UserActionType */].CLICK, 'continue_transaction', pageKey, '');
  };

  Object(compat_module["useEffect"])(function () {
    if (template !== 'none' && prevTemplate.current !== template) {
      showModal();
    }
  }, [template]);

  switch (template) {
    case onModalAction_actionType["b" /* modalType */].cancelTransactionModal:
      return Object(preact_min["h"])(
        material_ui_Modal["a" /* default */],
        {
          open: open,
          onClose: function onClose() {
            _closeModal();
            sendCancelTransactionTracking();
          },
          className: modals_style_default.a.modalContainer,
          disableBackdropClick: true,
          disableEscapeKeyDown: true },
        Object(preact_min["h"])(
          'div',
          { className: modals_style_default.a.modalBody },
          Object(preact_min["h"])(cancelTransactionModal, {
            closeModal: function closeModal() {
              _closeModal();
              sendCancelTransactionTracking();
            }
          })
        )
      );
    case onModalAction_actionType["b" /* modalType */].helpTransactionModal:
      return Object(preact_min["h"])(
        material_ui_Modal["a" /* default */],
        {
          open: open,
          onClose: _closeModal,
          className: modals_style_default.a.modalContainer },
        Object(preact_min["h"])(
          'div',
          { className: modals_style_default.a.modalBody },
          Object(preact_min["h"])(helpTransactionModal, { closeModal: _closeModal })
        )
      );
    case onModalAction_actionType["b" /* modalType */].errorBlockTransactionModal:
      return Object(preact_min["h"])(
        material_ui_Modal["a" /* default */],
        {
          open: open,
          onClose: _closeModal,
          className: modals_style_default.a.modalContainer,
          disableBackdropClick: true,
          disableEscapeKeyDown: true },
        Object(preact_min["h"])(
          'div',
          { className: modals_style_default.a.modalBody },
          Object(preact_min["h"])(errorBlockTransactionModal, { closeModal: _closeModal })
        )
      );
    case onModalAction_actionType["b" /* modalType */].aivfTransactionInfoModal:
      return Object(preact_min["h"])(
        material_ui_Modal["a" /* default */],
        {
          open: open,
          onClose: _closeModal,
          className: modals_style_default.a.modalContainer,
          disableBackdropClick: true,
          disableEscapeKeyDown: true },
        Object(preact_min["h"])(
          'div',
          {
            className: modals_style_default.a.modalBody + ' ' + modals_style_default.a.aivfTransactionInfoModal },
          Object(preact_min["h"])(aivfInfoModal, { closeModal: _closeModal })
        )
      );
    case onModalAction_actionType["b" /* modalType */].limitCheckDetailsModal:
      return Object(preact_min["h"])(
        material_ui_Modal["a" /* default */],
        {
          open: open,
          onClose: _closeModal,
          className: modals_style_default.a.modalContainer },
        Object(preact_min["h"])(
          'div',
          { className: '' + modals_style_default.a.modalBody },
          modal__ref2
        )
      );
    case 'none':
      return null;
    default:
      console.info('Missing modal handling for: ' + template);
      return null;
  }
};

var modal_mapStateToProps = function mapStateToProps(_ref3) {
  var modal = _ref3.modal,
      config = _ref3.config;

  var _ref4 = config || {},
      pageKey = _ref4.pageKey;

  var _ref5 = modal || {},
      template = _ref5.template;

  return {
    template: template,
    pageKey: pageKey
  };
};

/* harmony default export */ var modal = __webpack_exports__["default"] = (Object(es["b" /* connect */])(modal_mapStateToProps, { onModalAction: actions_onModalAction })(modal_Modal));

/***/ }),

/***/ "A6R7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GenericLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loader_css__ = __webpack_require__("FgT3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loader_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_spinner__ = __webpack_require__("DC/1");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @jsx h */




var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  { style: 'margin-top:24px;' },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__spinner_spinner__["a" /* default */], null)
);

var GenericLoader = function (_Component) {
  _inherits(GenericLoader, _Component);

  function GenericLoader() {
    _classCallCheck(this, GenericLoader);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  GenericLoader.prototype.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { align: 'center' },
      _ref,
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': '' + __WEBPACK_IMPORTED_MODULE_1__loader_css___default.a.loaderText, style: 'margin:24px;' },
        this.props.loadingMsg
      )
    );
  };

  return GenericLoader;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "FgT3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loaderText":"loaderText__zWl3d","mdc-dialog--open":"mdc-dialog--open__tYYNH","mdc-dialog__backdrop":"mdc-dialog__backdrop__3Ppnd"};

/***/ }),

/***/ "FipF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_compat__ = __webpack_require__("AQ6k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_css__ = __webpack_require__("YGqN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spinLoader__ = __webpack_require__("0GrG");


/** @jsx h */





var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__spinLoader__["a" /* default */], { size: 'small' });

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { src: 'https://iccdn.in/img/forward.png' });

var BlockResult = function BlockResult(props) {
  var visibilityTimeUntilRedirect = props.visibilityTimeUntilRedirect,
      submitFormCallback = props.submitFormCallback,
      displayMessage = props.displayMessage,
      buttonText = props.buttonText;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_preact_compat__["useState"])(visibilityTimeUntilRedirect),
      redirectTimer = _useState[0],
      setRedirectTimer = _useState[1];

  Object(__WEBPACK_IMPORTED_MODULE_1_preact_compat__["useEffect"])(function () {
    var interval = setInterval(function () {
      setRedirectTimer(function (seconds) {
        return seconds - 1;
      });
    }, 1000);
    if (redirectTimer === 0) {
      submitFormCallback();
      clearInterval(interval);
    }
    return function () {
      return clearInterval(interval);
    };
  }, [redirectTimer]);

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_2__style_css___default.a.loaderContainer },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2__style_css___default.a.loader },
        _ref
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { className: 'bold-text text-center' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'span',
          { className: 'font14 text60', id: 'redirectionLoaderText' },
          displayMessage
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'span',
          { className: 'text-color bold-text', style: { opacity: 1 } },
          redirectTimer,
          ' second',
          redirectTimer > 1 ? 's' : ''
        )
      )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_2__style_css___default.a.redirectWrapper },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_2__style_css___default.a.bottomLink + ' cursorPointer',
          onClick: submitFormCallback },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'span',
          { className: 'linkColor bold-text font14', id: 'redirectionLinkText' },
          buttonText,
          ' '
        ),
        ' ',
        _ref2
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (BlockResult);

/***/ }),

/***/ "GRKX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"horizontalCenter":"horizontalCenter__3Pva6","loaderText":"loaderText__1xcGY"};

/***/ }),

/***/ "H/Gn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  initiateCancellation: 'initiateCancellation',
  rejectCancellation: 'rejectCancellation',
  confirmCancellation: 'confirmCancellation'
});

/***/ }),

/***/ "PQwg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__GUCBf","bodyWrapper":"bodyWrapper__2qG7j","loaderWrapper":"loaderWrapper__15J73","successMessage":"successMessage__1uzZ8","confirmCancellation":"confirmCancellation__3-n9Y","listSubHeading":"listSubHeading__1CrMq","textAreaContainer":"textAreaContainer__1ifio","buttonContainer":"buttonContainer__3ojO-","labelText":"labelText__1WQ01","outerButtonContainer":"outerButtonContainer__39PV3","radioContainer":"radioContainer__58iFW","orText":"orText__3En8Y"};

/***/ }),

/***/ "U1xn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"checkLimitText":"checkLimitText__1HfpR","successLogoContainer":"successLogoContainer__O6BHJ","successLogoInnerContainer":"successLogoInnerContainer__2oQPs","successLogo":"successLogo__1X62V","checkLimitHeading":"checkLimitHeading__3RF96","closeIconContainer":"closeIconContainer__2OQn1","closeIcon":"closeIcon__zianN","lenderLogoContainer":"lenderLogoContainer__1l3M9","checkLimitPromptText":"checkLimitPromptText__1RfXX","innerText":"innerText__1jQX_"};

/***/ }),

/***/ "Wk37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__KO_Pm","headerContainer":"headerContainer__FztDQ","submitButton":"submitButton__3UHPx","helperText":"helperText__1Gm2S","redirect__wrapper":"redirect__wrapper__94mEp","loader":"loader__oHfcM","redirect__text":"redirect__text__3hXAt","timer":"timer__IWwhI","buttonWrapper":"buttonWrapper__WlDlI","goBackButton":"goBackButton__2COgO"};

/***/ }),

/***/ "YGqN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"infoText":"infoText__3mIQH","loaderContainer":"loaderContainer__3AsjL","redirectWrapper":"redirectWrapper__3Y6Z0","bottomLink":"bottomLink__1r-yr","loader":"loader__BC3s3"};

/***/ }),

/***/ "Z5MC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modalContainer":"modalContainer__1dn5i","modalBody":"modalBody__24wZQ","aivfTransactionInfoModal":"aivfTransactionInfoModal__1-iRn"};

/***/ }),

/***/ "aGVp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"aivfInfoContainer":"aivfInfoContainer__2LWz_","aivfInfoHeaderContainer":"aivfInfoHeaderContainer__1Nx7q","aivfHeaderText":"aivfHeaderText__3QOms","aivfInfoBodyContainer":"aivfInfoBodyContainer__1mxn8","bodyContainer":"bodyContainer__2VEp1","purchaseButtonContainer":"purchaseButtonContainer__zROBD","cardInfoText":"cardInfoText__17tNR","cardInfoContainer":"cardInfoContainer__K_uqu","cardInfoTextContainer":"cardInfoTextContainer__oo4LP","leftImageContainer":"leftImageContainer__1_fSd","buttonContainer":"buttonContainer__1QxqG"};

/***/ }),

/***/ "iFvE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal__wrapper":"modal__wrapper__3Z_H5","modal__backdrop":"modal__backdrop__3aky_","limitCheckBackground":"limitCheckBackground__25tgI","clickable":"clickable__SdwF_","modal__container":"modal__container__33Ya4"};

/***/ }),

/***/ "pgW2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_material_components_Button__ = __webpack_require__("7/cg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_material_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact_material_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_spinner__ = __webpack_require__("DC/1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracking__ = __webpack_require__("Z0Lr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_preact_material_components_Button_style_css__ = __webpack_require__("aqQ4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_preact_material_components_Button_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_preact_material_components_Button_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_css__ = __webpack_require__("GRKX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_css__);

/** @jsx h */







var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__spinner_spinner__["a" /* default */], { style: 'margin: 0 auto;' });

var SubmitButton = function SubmitButton(_ref) {
  var _ref$requestStatus = _ref.requestStatus,
      requestStatus = _ref$requestStatus === undefined ? false : _ref$requestStatus,
      _ref$buttonDisabled = _ref.buttonDisabled,
      buttonDisabled = _ref$buttonDisabled === undefined ? false : _ref$buttonDisabled,
      buttonText = _ref.buttonText,
      className = _ref.className,
      _ref$pageKey = _ref.pageKey,
      pageKey = _ref$pageKey === undefined ? 'Missing PageKey' : _ref$pageKey,
      _ref$elementName = _ref.elementName,
      elementName = _ref$elementName === undefined ? 'Missing ElementName' : _ref$elementName,
      _ref$buttonId = _ref.buttonId,
      buttonId = _ref$buttonId === undefined ? 'submitButton' : _ref$buttonId,
      _ref$loadingMsg = _ref.loadingMsg,
      loadingMsg = _ref$loadingMsg === undefined ? '' : _ref$loadingMsg,
      buttonOnClick = _ref.buttonOnClick,
      _ref$metadata = _ref.metadata,
      metadata = _ref$metadata === undefined ? {} : _ref$metadata,
      _ref$trackClickEvent = _ref.trackClickEvent,
      trackClickEvent = _ref$trackClickEvent === undefined ? true : _ref$trackClickEvent;

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_5__style_css___default.a.horizontalCenter },
    !requestStatus ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: 'genericButtonContainer' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_1_preact_material_components_Button___default.a,
        {
          raised: true,
          ripple: true,
          className: 'fpPrimaryButton ' + className,
          id: buttonId,
          onClick: function onClick() {
            if (trackClickEvent) {
              clickTracking({ pageKey: pageKey, elementName: elementName, metadata: metadata });
            }
            buttonOnClick();
          },
          disabled: buttonDisabled,
          primary: false,
          style: {
            backgroundColor: '#5bb556'
          } },
        buttonText
      )
    ) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { style: 'text-align:center;' },
      _ref2,
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5__style_css___default.a.loaderText },
        loadingMsg
      )
    )
  );
};

var clickTracking = function clickTracking(_ref3) {
  var pageKey = _ref3.pageKey,
      elementName = _ref3.elementName,
      metadata = _ref3.metadata;

  __WEBPACK_IMPORTED_MODULE_3__tracking__["e" /* tracker */].trackUserInteraction(__WEBPACK_IMPORTED_MODULE_3__tracking__["c" /* UserActionType */].CLICK, elementName, pageKey, metadata);
};

/* harmony default export */ __webpack_exports__["a"] = (SubmitButton);

/***/ }),

/***/ "t9ax":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_compat__ = __webpack_require__("AQ6k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("jYI/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_css__ = __webpack_require__("iFvE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


/** @jsx h */





var Modal = function Modal(props) {
  Modal.defaultProps = {
    open: false,
    disableBackdropClick: false,
    disableEscapeKeyDown: false,
    className: '',
    modalStyle: {}
  };

  var onClose = props.onClose,
      open = props.open,
      disableBackdropClick = props.disableBackdropClick,
      disableEscapeKeyDown = props.disableEscapeKeyDown,
      children = props.children,
      className = props.className,
      modalStyle = props.modalStyle;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_preact_compat__["useState"])(open || false),
      openModal = _useState[0],
      setOpenModal = _useState[1];

  var _useState2 = Object(__WEBPACK_IMPORTED_MODULE_1_preact_compat__["useState"])(false),
      isLimitCheckModal = _useState2[0],
      setIsLimitCheckModal = _useState2[1];

  Object(__WEBPACK_IMPORTED_MODULE_1_preact_compat__["useEffect"])(function () {
    if (props.lenderId) {
      setIsLimitCheckModal(true);
    }
  }, [props.lenderId]);

  var showModal = Object(__WEBPACK_IMPORTED_MODULE_1_preact_compat__["useCallback"])(function () {
    setOpenModal(true);
    document.body.style.overflow = 'hidden';
  }, []);

  var handleKeyDown = Object(__WEBPACK_IMPORTED_MODULE_1_preact_compat__["useCallback"])(function (event) {
    if (event.keyCode === 27 && !disableEscapeKeyDown) {
      closeModal(event);
    }
  }, []);

  var handleBackDropClick = Object(__WEBPACK_IMPORTED_MODULE_1_preact_compat__["useCallback"])(function (event) {
    if (!disableBackdropClick) {
      closeModal(event);
    }
  }, []);

  var cleanUp = function cleanUp() {
    removeEvent();
    setOpenModal(false);
    document.body.style.overflow = null;
  };

  var closeModal = function closeModal(event) {
    cleanUp();
    if (onClose) {
      onClose(event);
    }
  };

  var addEvent = Object(__WEBPACK_IMPORTED_MODULE_1_preact_compat__["useCallback"])(function () {
    window.addEventListener('keydown', handleKeyDown, false);
  }, []);

  var removeEvent = Object(__WEBPACK_IMPORTED_MODULE_1_preact_compat__["useCallback"])(function () {
    window.removeEventListener('keydown', handleKeyDown, false);
  }, []);

  Object(__WEBPACK_IMPORTED_MODULE_1_preact_compat__["useEffect"])(function () {
    if (open && openModal !== open) {
      showModal();
      addEvent();
    }
    return function () {
      cleanUp();
    };
  }, [open]);

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    __WEBPACK_IMPORTED_MODULE_0_preact__["Fragment"],
    null,
    open && openModal && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_3__style_css___default.a.modal__wrapper + ' ' + className },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__style_css___default.a.modal__backdrop + ' ' + (isLimitCheckModal && __WEBPACK_IMPORTED_MODULE_3__style_css___default.a.limitCheckBackground) + ' ' + (!disableBackdropClick && __WEBPACK_IMPORTED_MODULE_3__style_css___default.a.clickable),
        onClick: handleBackDropClick
      }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3__style_css___default.a.modal__container, style: _extends({}, modalStyle) },
        children
      )
    )
  );
};

var mapStateToProps = function mapStateToProps(_ref) {
  var modal = _ref.modal;

  var _ref2 = modal || {},
      limitCheck = _ref2.limitCheck;

  var lenderId = limitCheck.lenderId;


  return {
    lenderId: lenderId
  };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(Modal));

/***/ }),

/***/ "vZQi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__3Qgbe","headerContainer":"headerContainer__xW8rW","submitButton":"submitButton__1lzot"};

/***/ }),

/***/ "wM4X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css__ = __webpack_require__("U1xn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_css__);



var limitCheckInfo = {
  501: { text: 'MYHDFC', number: 5676712, smsPrefillTxt: 'MYHDFC' },
  701: { text: 'CARDLESS', number: 5676766, smsPrefillTxt: 'CARDLESS' },
  401: {
    text: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: 'text-center bold-text font20' },
      'DCEMI',
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        { className: __WEBPACK_IMPORTED_MODULE_1__style_css___default.a.innerText },
        '<space><'
      ),
      'Last 4 digits of Kotak Debit Card Number',
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        { className: __WEBPACK_IMPORTED_MODULE_1__style_css___default.a.innerText },
        '>'
      )
    ),
    number: 5676788,
    smsPrefillTxt: 'DCEMI <Last 4 digits of Kotak Debit Card Number>'
  },
  901: {
    text: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: 'text-center bold-text font20' },
      'PAPL',
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        { className: __WEBPACK_IMPORTED_MODULE_1__style_css___default.a.innerText },
        '<space><'
      ),
      'Last 4 digits of Debit Card Number',
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        { className: __WEBPACK_IMPORTED_MODULE_1__style_css___default.a.innerText },
        '>'
      )
    ),
    number: 8422009988,
    smsPrefillTxt: 'PAPL <Last 4 digits of Debit Card Number>'
  },
  201: {
    text: Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: 'text-center bold-text font20' },
      'EASYBUY',
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        { className: __WEBPACK_IMPORTED_MODULE_1__style_css___default.a.innerText },
        '<space><'
      ),
      'Last 4 digits of IDFC FIRST Bank card number',
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'span',
        { className: __WEBPACK_IMPORTED_MODULE_1__style_css___default.a.innerText },
        '>'
      )
    ),
    number: 5676732,
    smsPrefillTxt: 'EASYBUY <Last 4 digits of IDFC FIRST Bank card number>'
  }
};

/* harmony default export */ __webpack_exports__["a"] = (limitCheckInfo);

/***/ }),

/***/ "zed/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"cancelLink":"cancelLink__2bfPV","cancelButton":"cancelButton__14R_K","cancelButtonContainer":"cancelButtonContainer__EzH64"};

/***/ }),

/***/ "zhx8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./actions/onPaymentCancel/actionType.js
var onPaymentCancel_actionType = __webpack_require__("H/Gn");

// EXTERNAL MODULE: ./actionTypes/index.js
var actionTypes = __webpack_require__("9vGq");

// EXTERNAL MODULE: ./api/controllers/paymentController.js
var paymentController = __webpack_require__("DR7x");

// CONCATENATED MODULE: ./actions/onPaymentCancel/initiateCancel.js



var initiateCancel_initiateCancelTransaction = function initiateCancelTransaction() {
  return function (dispatch, getState) {
    var _getState = getState(),
        config = _getState.config;

    var _ref = config || {},
        sourceRef = _ref.sourceRef;

    dispatch({
      type: actionTypes["H" /* paymentCancelActionType */].CANCEL_TRANSACTION_REQUEST,
      payload: {}
    });
    paymentController["c" /* default */].postCancelTransaction(null, { sourceRef: sourceRef }).then(function (_ref2) {
      var respData = _ref2.data;

      var _ref3 = respData || {},
          pgData = _ref3.pgData,
          returnUrl = _ref3.returnUrl;

      dispatch({
        type: actionTypes["H" /* paymentCancelActionType */].CANCEL_TRANSACTION_SUCCESS,
        payload: { pgData: pgData, returnUrl: returnUrl }
      });
    }).catch(function (errorData) {
      dispatch({
        type: actionTypes["H" /* paymentCancelActionType */].CANCEL_TRANSACTION_ERROR,
        payload: {}
      });
    });
  };
};
// EXTERNAL MODULE: ./actions/onModalAction/actionType.js
var onModalAction_actionType = __webpack_require__("ptCC");

// CONCATENATED MODULE: ./actions/onPaymentCancel/index.js





/* harmony default export */ var onPaymentCancel = __webpack_exports__["a"] = (function (actionType) {
  return function (dispatch) {
    switch (actionType) {
      case onPaymentCancel_actionType["a" /* default */].initiateCancellation:
        return dispatch({
          type: actionTypes["y" /* modalActionType */].SHOW_MODAL,
          payload: { modalType: onModalAction_actionType["b" /* modalType */].cancelTransactionModal }
        });
      case onPaymentCancel_actionType["a" /* default */].rejectCancellation:
        return dispatch({
          type: actionTypes["H" /* paymentCancelActionType */].REJECT_INITIATE_CANCEL_TRANSACTION,
          payload: {}
        });
      case onPaymentCancel_actionType["a" /* default */].confirmCancellation:
        return dispatch(initiateCancel_initiateCancelTransaction());
      default:
        return null;
    }
  };
});

/***/ })

});


// WEBPACK FOOTER //
// lazy-modal-chunk.chunk.4673c.js